module.exports = __webpack_public_path__ + "img/checklist-verified.c42bb4b5.svg";